import { render, staticRenderFns } from "./ModalDocCard.vue?vue&type=template&id=9f927b02"
import script from "./ModalDocCard.vue?vue&type=script&lang=js"
export * from "./ModalDocCard.vue?vue&type=script&lang=js"
import style0 from "./ModalDocCard.vue?vue&type=style&index=0&id=9f927b02&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports